export default __webpack_public_path__ + "static/media/Pilgrim's Bracers of the Purple Sun.b8da3514.jpg";